import Lottie from "react-lottie";
import animation from "./Animation.json";
import { createPortal } from "react-dom";
import { useAnimationStore } from "./exposion.store";
import { useEffect, useState } from "react";

const Explosion = () => {
  const { isVisible, hideAnimation } = useAnimationStore();

  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);


  if (!mounted || !isVisible) return null;

  return createPortal(
    <div
      style={{
        position: "fixed",
        top: "0",
        left: "0",
        zIndex: 9999,
        pointerEvents: "none",
      }}
    >
      <Lottie
        options={{
          loop: false,
          autoplay: true,
          animationData: animation,
        }}
        height={471}
        eventListeners={[
          {
            eventName: "complete",
            callback: () => {
              hideAnimation();
            },
          },
        ]}
      />
    </div>,
    document.body
  );
};

export default Explosion;
